import { Directive, HostBinding, Input } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';

@Directive({
  selector: 'img[src]',
  host: {
    '[src]': 'checkPath(src)',
    '(error)': 'onError()',
  },
})
export class DefaultImageDirective {
  private isError = false;
  private originSrc: string | SafeResourceUrl = null;

  @Input() src: string | SafeResourceUrl;
  @Input() defaultImg = 'assets/images/no-image.svg';

  @HostBinding('class') get isDefault(): string {
    return this.isError ? 'fuse-white default-image check-image-errors' : 'check-image-errors';
  }

  @HostBinding('attr.origin-src') get originalSrc(): string | SafeResourceUrl | null {
    return this.originSrc;
  }

  public onError() {
    this.originSrc = this.src;
    this.src = this.defaultImg;
    this.isError = true;
  }

  public checkPath(src: string | null | undefined | SafeResourceUrl) {
    if (!src && this.defaultImg) {
      this.onError();
    }

    return src;
  }
}
